import { render, staticRenderFns } from "./NotificacionesAlertas.vue?vue&type=template&id=9dd24b9a&scoped=true&"
import script from "./NotificacionesAlertas.vue?vue&type=script&lang=ts&"
export * from "./NotificacionesAlertas.vue?vue&type=script&lang=ts&"
import style0 from "./NotificacionesAlertas.vue?vue&type=style&index=0&id=9dd24b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd24b9a",
  null
  
)

export default component.exports